// Id aleatório do aparelho pra quem ainda não entrou: sorteia uma amostra
// plausível de cards marcados, igual à que a pessoa teria de verdade.
const CHAVE = "nucleo_anon_id";

export function obterAnonId() {
  try {
    let id = localStorage.getItem(CHAVE);
    if (!id || !/^[A-Za-z0-9-]{8,64}$/.test(id)) {
      id = window.crypto?.randomUUID?.()
        || `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 14)}`;
      localStorage.setItem(CHAVE, id);
    }
    return id;
  } catch {
    return null;
  }
}
